import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

export const Overlay = styled.div`
 	position: relative;
	grid-row: 1/-1;
	grid-column: 1/-1;
	z-index: 2;

	pointer-events: all;
	user-select: none;
	width: 100%;
	height: 100%;
	justify-content: center;
	align-items: center;
	display: flex;
	opacity: 1;

	max-width: ${Breakpoints.b560 - 1}px){
	${props => `padding-bottom: ${props.theme.size.static550}`}
	}
`;
